<template lang='pug'>
div.mt-3
  .text-center.my-3(v-if='showHeader')
    | {{ $t('js.wizard.job_list.passende_stellenangebote') }}

  ul.list-group.rounded-md
    job-list-item.list-group-item(v-for='job in showJobs' :key='job.id' :job='job' :organisation='organisation')
    li.list-group-item(v-if='jobs.length > show')
      button.btn.btn-link(@click='show = 999')
        | {{ $t('js.wizard.job_list.mehr_jobs_length_show_anze', { jobs_length_show: (jobs.length - show) }) }}


      .text-center.mt-5(v-if='organisation.unsolicited_enabled')
        button.btn.btn-primary.btn-sm.p-3(@click.prevent='apply' :style='buttonStyle')
          | {{ $t('js.wizard.job_list.initiativ_bewerben') }}

  collapse-transition
    div(v-if='open')
      job-modal.mt-5(:job='job' :organisation='organisation' ref='modal')
      .d-flex.justify-content-end.mt-5
        button.btn.btn-outline-dark(@click.prevent='toggleOpen')
          | {{ $t('js.wizard.job_list_item.stelle_einklappen') }}
</template>

<script lang='ts' setup>
import { ref, computed, nextTick } from 'vue'
import JobListItem from '@/wizard/JobListItem.vue'
import JobModal from "@/wizard/JobModal.vue"
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition.vue"

const show = ref(3)

const props = defineProps<{
  jobs: frontend.Job[]
  organisation: frontend.Organisation
  showHeader: boolean
}>()
const open = ref(false)
const modal = ref<JobModal | null>(null)

const showJobs = computed(() => {
  return props.jobs.slice(0, show.value)
})

const apply = () => {
  open.value = true
  nextTick(() => {
    setTimeout(() => {
      if (modal.value && modal.value.apply) {
        const el = modal.value.apply
        el.scrollIntoView({ behavior: "smooth" })
      }
    }, 300)
  })
}

function getTextColor(backgroundColor: string | null | undefined): string {
  if (!backgroundColor) return '#ffffff'

  const rgb = backgroundColor.startsWith('#') ? backgroundColor : '#000000'
  const r = parseInt(rgb.slice(1, 3), 16)
  const g = parseInt(rgb.slice(3, 5), 16)
  const b = parseInt(rgb.slice(5, 7), 16)
  const luminosity = (0.299 * r + 0.587 * g + 0.114 * b) / 255 * 100

  return luminosity < 50 ? '#f3f3f3' : '#000'
}

const buttonStyle = computed(() => {
  return {
    backgroundColor: props.organisation.company_color,
    color: getTextColor(props.organisation.company_color)
  }
})
</script>

<style scoped>
.list-group-item {
  border-width: 0px;
}
</style>
